import { useCallback, useMemo } from 'react';
import {
  AU_STATES,
  CURRENCIES,
  DEAL_ROOM_TOTAL_PACKAGE_GST,
  NZ_REGIONS,
  STOCK_AT_VALUE,
  DealRoomLocation,
} from 'models/DealRoom';
import { useTranslation } from 'react-i18next';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';

export default function useFirstStepValues() {
  const { t } = useTranslation();

  const createSelectOptions = useCreateSelectOptions();

  const dealLocationOptions = useMemo(
    () => [
      {
        value: 'au',
        label: t('australia'),
        disabled: true,
      },
      ...createSelectOptions(Object.values(AU_STATES)),
      {
        value: 'nz',
        label: t('newZealand'),
        disabled: true,
      },
      ...createSelectOptions(Object.values(NZ_REGIONS)),
    ],
    [t, createSelectOptions],
  );

  const currencyOptions = useMemo(
    () => [
      { value: CURRENCIES.AUD, label: t('$aud') },
      { value: CURRENCIES.NZD, label: t('$nzd') },
    ],
    [t],
  );

  const gstOptions = useMemo(
    () => createSelectOptions(Object.values(DEAL_ROOM_TOTAL_PACKAGE_GST)),
    [createSelectOptions],
  );

  const includesSAVOptions = useMemo(
    () => [
      {
        label: t('excludesStock'),
        value: STOCK_AT_VALUE.EXCLUDE_STOCK_AT_VALUE,
      },
      {
        label: t('includesStock'),
        value: STOCK_AT_VALUE.INCLUDE_STOCK_AT_VALUE,
      },
      { label: t('noStock'), value: STOCK_AT_VALUE.NO_STOCK_AT_VALUE },
    ],
    [t],
  );

  const checkIfLocationIsAU = useCallback(
    (location: DealRoomLocation) =>
      Object.values(AU_STATES).some((el) => el === location),
    [],
  );

  return {
    gstOptions,
    dealLocationOptions,
    currencyOptions,
    includesSAVOptions,
    checkIfLocationIsAU,
  };
}
